<template>
	<view class="index">
		<view class="index_list">
			<view class="index_list_item">
				<view class="index_list_item_info">
					<text>SHE事件上报</text>
					<text>FAC/NM</text>
				</view>
				<image src="/static/bg_a.png" mode="widthFix"></image>
			</view>
			<view class="index_list_item">
				<view class="index_list_item_info">
					<text>跌绊滑风险上报</text>
					<text>TAG</text>
				</view>
				<image src="/static/bg_b.png" mode="widthFix"></image>
			</view>
		</view>
	</view>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		computed: {
			...mapState(['userInfo'])
		},
		data() {
			return {
				title: 'Hello'
			}
		},
		onLoad() {

		},
		methods: {
			jump(type) {
				switch (type) {
					case 1:
						uni.navigateTo({
							url: '/pages/reporting_she/reporting_she'
						})
						break;
					case 2:
						uni.navigateTo({
							url: '/pages/riskReporting/riskReporting'
						})
						break;
					case 3:
						uni.navigateTo({
							url: '/pages/report_dca/report_dca'
						})
						break;
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.index {
		width: 100vw;
		padding: 30rpx;
		box-sizing: border-box;
		height: calc(100vh - 44px - 50px);
		background: linear-gradient( 180deg, #B5D2FF 0%, #FFFFFF 100%);
		.index_list {
			width: 100%;
			display: flex;
			flex-direction: column;
			margin-top: 12rpx;
			.index_list_item {
				width: 100%;
				height: 200rpx;
				margin-bottom: 30rpx;
				position: relative;
				.index_list_item_info {
					width: 100%;
					height: 100%;
					padding: 0 48rpx;
					box-sizing: border-box;
					display: flex;
					justify-content: center;
					flex-direction: column;
					position: relative;
					z-index: 99;
					text {
						&:nth-child(1) {
							font-weight: bold;
							font-size: 34rpx;
							color: #FFFFFF;
						}
						&:nth-child(2) {
							font-weight: 400;
							font-size: 26rpx;
							color: rgba(255,255,255,0.6);
							margin-top: 10rpx;
						}
					}
				}
				image {
					width: 100%;
					height: 100%;
					position: absolute;
					top: 0;
					left: 0;
				}
			}
		}
	}
</style>
